import { GameTopBarProperties } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/properties/GameTopBarProperties";
import { GameStyle } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/style/GameStyle";
import { FontStyle } from "@lib/titan2-slingo/dist/game/view/abstract/style/FontStyle";
import { SlingoStyle } from "@lib/titan2-slingo/dist/game/view/abstract/style/SlingoStyle";
import { ControlConstants } from "@lib/titan2/dist/game/control/constant/ControlConstants";
import { ClockProperties } from "@lib/titan2/dist/game/control/properties/ClockProperties";
import { SpriteProperties } from "@lib/titan2/dist/game/control/properties/SpriteProperties";
import { TextFieldProperties } from "@lib/titan2/dist/game/control/properties/TextFieldProperties";
import { Point } from "pixi.js";
export class TopBarLandscapeProperties extends GameTopBarProperties {
    constructor() {
        super();
        this.backgroundProperties = new SpriteProperties(SlingoStyle.NAVIGATION_BACKGROUND, GameStyle.MODULE);
        this.gameIdProperties = new TextFieldProperties(FontStyle.MESSAGE_BAR);
        this.clockProperties = new ClockProperties(FontStyle.CLOCK);
        this.fieldOffset = -66;
        this.fullScreenOffset = 75;
        this.backgroundProperties.position.set(973, 0);
        this.backgroundProperties.scale.set(1, 1.25);
        this.backgroundProperties.anchor.set(0.5, 0);
        this.clockProperties.position.set(2336, 5);
        this.clockProperties.horizontalAlign = ControlConstants.RIGHT;
        this.gameIdProperties.position.set(0, 5);
        this.gameIdProperties.size = new Point(280, 57);
        this.gameIdProperties.horizontalAlign = ControlConstants.LEFT;
    }
}
//# sourceMappingURL=TopBarLandscapeProperties.js.map